import {KeycloakConfig} from 'keycloak-js';

export const environment = {
  production: true,
  baseURL: '/api',
  auth: {
    url: 'https://fit.uni-kassel.de/auth',
    realm: 'FIT',
    clientId: 'web',
  } satisfies KeycloakConfig,
  staleUsers: {
    warning: 12,
    inactive: 13,
  },
  topics: '/topics',
  articles: '/articles',
  users: '/users',
  institutions: '/institutions',
  statistics: '/statistics',
  internalMessages: '/internalMessages',
  mailing: '/mailing',
  adminMail: '/adminMail',
  contacts: '/contacts',
  admin: '/admin',
};
